import { startAuthentication, startRegistration } from "@simplewebauthn/browser";
import { api } from "./api.js";

type CreationOptions = Parameters<typeof startRegistration>[0]["optionsJSON"];
type RequestOptions = Parameters<typeof startAuthentication>[0]["optionsJSON"];

export async function registerPasskey(input: {
  name: string;
  setupToken?: string;
  inviteToken?: string;
}) {
  const options = await api<CreationOptions>("/v1/auth/register/options", { body: input });
  const response = await startRegistration({ optionsJSON: options });
  return api<{ user: { id: string; role: "owner" | "confidant"; name: string } }>(
    "/v1/auth/register/verify",
    {
      body: response,
    },
  );
}

export async function loginPasskey() {
  const options = await api<RequestOptions>("/v1/auth/login/options", { body: {} });
  const response = await startAuthentication({ optionsJSON: options });
  return api<{ user: { id: string; role: "owner" | "confidant"; name: string } }>(
    "/v1/auth/login/verify",
    {
      body: response,
    },
  );
}

export async function logout() {
  await api("/v1/auth/logout", { body: {} });
}

export function passkeysSupported(): boolean {
  return typeof window !== "undefined" && !!window.PublicKeyCredential;
}

/** WebAuthn refuses IP-address origins. Tell the user to use localhost or a real hostname. */
export function passkeyHostnameProblem(): string | null {
  const h = window.location.hostname;
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(h) || h.startsWith("[")) {
    return `Passkeys do not work on an IP address (${h}). Open this page via http://localhost:${window.location.port || "80"} or through the gateway's domain name.`;
  }
  return null;
}
